const itConversion = {
  50: {
    rank: 99,
    score: 140,
    class: 'very superior',
  },
  49: {
    rank: 99,
    score: 138,
    class: 'very superior',
  },
  48: {
    rank: 99,
    score: 136,
    class: 'very superior',
  },
  47: {
    rank: 99,
    score: 134,
    class: 'very superior',
  },
  46: {
    rank: 98,
    score: 132,
    class: 'very superior',
  },
  45: {
    rank: 98,
    score: 130,
    class: 'very superior',
  },
  44: {
    rank: 97,
    score: 128,
    class: 'superior',
  },
  43: {
    rank: 96,
    score: 126,
    class: 'superior',
  },
  42: {
    rank: 95,
    score: 125,
    class: 'superior',
  },
  41: {
    rank: 93,
    score: 122,
    class: 'superior',
  },
  40: {
    rank: 92,
    score: 121,
    class: 'superior',
  },
  39: {
    rank: 88,
    score: 118,
    class: 'high average',
  },
  38: {
    rank: 87,
    score: 117,
    class: 'high average',
  },
  37: {
    rank: 82,
    score: 114,
    class: 'high average',
  },
  36: {
    rank: 81,
    score: 113,
    class: 'high average',
  },
  35: {
    rank: 75,
    score: 110,
    class: 'high average',
  },
  34: {
    rank: 73,
    score: 109,
    class: 'average',
  },
  33: {
    rank: 66,
    score: 106,
    class: 'average',
  },
  32: {
    rank: 63,
    score: 105,
    class: 'average',
  },
  31: {
    rank: 55,
    score: 102,
    class: 'average',
  },
  30: {
    rank: 50,
    score: 100,
    class: 'average',
  },
  29: {
    rank: 45,
    score: 98,
    class: 'average',
  },
  28: {
    rank: 37,
    score: 95,
    class: 'average',
  },
  27: {
    rank: 34,
    score: 94,
    class: 'average',
  },
  26: {
    rank: 27,
    score: 91,
    class: 'average',
  },
  25: {
    rank: 25,
    score: 90,
    class: 'average',
  },
  24: {
    rank: 19,
    score: 87,
    class: 'low average',
  },
  23: {
    rank: 18,
    score: 86,
    class: 'low average',
  },
  22: {
    rank: 13,
    score: 83,
    class: 'low average',
  },
  21: {
    rank: 12,
    score: 82,
    class: 'low average',
  },
  20: {
    rank: 8,
    score: 79,
    class: 'below average',
  },
  19: {
    rank: 7,
    score: 78,
    class: 'below average',
  },
  18: {
    rank: 5,
    score: 75,
    class: 'below average',
  },
  17: {
    rank: 4,
    score: 74,
    class: 'below average',
  },
  16: {
    rank: 3,
    score: 71,
    class: 'below average',
  },
  15: {
    rank: 2,
    score: 70,
    class: 'below average',
  },
  14: {
    rank: 1,
    score: 67,
    class: 'well below average',
  },
  13: {
    rank: 1,
    score: 66,
    class: 'well below average',
  },
  12: {
    rank: 1,
    score: 63,
    class: 'well below average',
  },
  11: {
    rank: 1,
    score: 62,
    class: 'well below average',
  },
  10: {
    rank: 1,
    score: 59,
    class: 'well below average',
  },
  9: {
    rank: 1,
    score: 58,
    class: 'well below average',
  },
  8: {
    rank: 1,
    score: 55,
    class: 'well below average',
  },
  7: {
    rank: 1,
    score: 54,
    class: 'well below average',
  },
  6: {
    rank: 1,
    score: 51,
    class: 'well below average',
  },
  5: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  4: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  3: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  2: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  1: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  0: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
};

export default itConversion;
